export default "__VITE_ASSET__CurvCw_7__"